
import * as users from './users'
import * as biddingNotice from './BiddingNotice'
import * as billBusinessInfo from './billBusinessInfo'
// 竞价公告
import * as bidAuctionResult from './BidAuctionResult'
import * as file from './file'


export default{
    users,
    billBusinessInfo,
    biddingNotice,
    bidAuctionResult,
    file,
}